<template>
    <div class="registration">
        <div class="text-center mb-5" v-if="!registration">
            <h2 v-if="!org">Join CAT-UXO</h2>
            <h1>Create your account</h1>
            <h2 v-if="org">You've been invited to join {{ org.name }} on CAT-UXO</h2>
        </div>
        <section v-if="registration !== true" class="column is-8-desktop px-0 px-sm-2 mx-auto">
            <form method="POST" class="form form-register  bg-white p-5 shadow rounded-lg">
                <div class="account-details d-flex flex-column justify-content-center">
                    <div class="columns">
                        <div class="column is-half">
                            <div class="field mb-4" :class="{ 'has-error': $v.form.fullName.$error }">
                                <label class="label mb-1" for="fullName">Full Name*</label>
                                <div class="control">
                                    <input id="fullName" name="full_name" class="input" type="text"
                                           v-model.trim="$v.form.fullName.$model"/>
                                </div>
                                <div class="error" v-if="$v.$dirty && $v.form.fullName.$error">
                                    {{ getErrorMessage($v.form.fullName) }}
                                </div>
                            </div>
                        </div>
                        <div class="column is-half">
                            <div class="field mb-4" :class="{ 'has-error': $v.form.email.$error }">
                                <label class="label mb-1" for="email">Email Address*</label>
                                <div class="control">
                                    <input id="email" name="email" class="input" type="email"
                                           v-model.trim="$v.form.email.$model"/>
                                </div>
                                <div class="error" v-if="$v.$dirty && $v.form.email.$error">
                                    {{ getErrorMessage($v.form.email) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="!org">
                        <div class="columns">
                            <div class="column is-half">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.country.$error }">
                                    <label class="label mb-1" for="nationality">Nationality*</label>
                                    <div class="control">
                                        <select id="nationality" name="nationality" class="select"
                                                v-model.trim="$v.form.country.$model">
                                            <option value="null" selected>Select your nationality</option>
                                            <option v-for="(country) in countries" :value="country.code">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.trainedAt.$error }">
                                    <label class="label mb-1" for="trainedAt">Where did you attend your EOD
                                        training?*</label>
                                    <div class="control">
                                        <input id="trainedAt" name="trained_at" class="input" type="text"
                                               v-model.trim="$v.form.trainedAt.$model"/>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.trainedAt.$error">
                                        {{ getErrorMessage($v.form.trainedAt) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.currentWork.$error }">
                                    <label class="label mb-1" for="currentWork">Where do you work at the
                                        moment?*</label>
                                    <div class="control">
                                        <input id="currentWork" name="current_work" class="input" type="text"
                                               v-model.trim="$v.form.currentWork.$model"/>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.currentWork.$error">
                                        {{ getErrorMessage($v.form.currentWork) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.explanation.$error }">
                                    <label class="label mb-1" for="explanation">Give a brief explanation of why you wish
                                        to
                                        become a member of CAT-UXO*</label>
                                    <div class="control">
                                    <textarea id="explanation" name="explanation" class="textarea"
                                              v-model.trim="$v.form.explanation.$model"></textarea>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.explanation.$error">
                                        {{ getErrorMessage($v.form.explanation) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-full">
                                <div class="field mb-4" :class="{ 'has-error': $v.form.purpose.$error }">
                                    <label class="label mb-1" for="purpose">What purpose do you wish to use CAT-UXO
                                        for?*</label>
                                    <div class="control">
                                    <textarea id="purpose" name="purpose" class="textarea"
                                              v-model.trim="$v.form.purpose.$model"></textarea>
                                    </div>
                                    <div class="error" v-if="$v.$dirty && $v.form.purpose.$error">
                                        {{ getErrorMessage($v.form.purpose) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="columns">
                        <div class="column is-half">
                            <div class="field mb-5" :class="{ 'has-error': $v.form.password.$error }">
                                <label class="label mb-1" for="password">Password*</label>
                                <div class="control">
                                    <input id="password" name="password" class="input" type="password"
                                           v-model.trim="$v.form.password.$model">
                                </div>
                                <div class="error" v-if="$v.$dirty && $v.form.password.$error">
                                    {{ getErrorMessage($v.form.password) }}
                                </div>
                            </div>
                        </div>
                        <div class="column is-half">
                            <div class="field mb-5" :class="{ 'has-error': $v.form.passwordConfirmation.$error }">
                                <label class="label mb-1" for="passwordConfirmation">Confirm Password*</label>
                                <div class="control">
                                    <input id="passwordConfirmation" name="password_confirmation" class="input"
                                           type="password" v-model.trim="$v.form.passwordConfirmation.$model"/>
                                </div>
                                <div class="error" v-if="$v.$dirty && $v.form.passwordConfirmation.$error">
                                    {{ getErrorMessage($v.form.passwordConfirmation) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-full">
                            <div class="field mb-3" :class="{ 'has-error': $v.form.toc.$error }">
                                <label class="position-relative d-flex align-items-center">
                                    <input name="toc" class="input-checkbox" type="checkbox"
                                           v-model.trim="$v.form.toc.$model"/>
                                    <span class="check-toggle"></span>
                                    <span class="toc ml-1 font-weight-light">Accept that you have read our
                                    <a class="btn-link" href="/privacy-policy">Privacy Policy</a> and <a
                                            class="btn-link" href="/terms-conditions"
                                            target="_blank">Terms & Conditions</a></span>
                                </label>
                                <div class="error" v-if="$v.$dirty && $v.form.toc.$error">
                                    {{ getErrorMessage($v.form.toc) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field mx-auto mb-3">
                        <button v-if="!loading" @click.prevent="createAccount" class="btn btn-form">
                            Create your account
                        </button>
                        <pulse-loader v-if="loading" :loading="true" :color="'#E57722'" :size="'20px'"></pulse-loader>
                    </div>
                </div>

                <div v-if="errors" class="errors mt-4">
                    <template v-for="(field) in errors">
                        <div v-for="(error) in field" class="error">{{ error }}</div>
                    </template>
                </div>

            </form>
        </section>

        <div class="notification mx-auto" v-if="registration === true">
            <div class="column is-1 mx-auto text-center mb-1">
                <img class="icon__email-sent" src="/img/icons/email-sent.svg" alt="Email icon"/>
            </div>
            <div class="column is-full mb-1">
                <h1 class="w-872 mx-auto text-center">You’ve successfully created your {{ user.plan }} account!</h1>
            </div>
            <div class="column is-full mb-4">
                <p class="w-648 t-black mx-auto text-center ">You’ve successfully created your {{ user.plan }} account.
                    If you want to edit your account details then head over to your user profile after logging in.</p>
            </div>
            <div class="column d-flex justify-content-center is-4 mx-auto">
                <a href="/login" class="btn">Login</a>
            </div>
        </div>
    </div>
</template>

<script>

import {axiosApi, axiosWeb} from "@/js/axios";
import {required, email, sameAs, requiredIf} from 'vuelidate/lib/validators';
import {Card, createToken} from 'vue-stripe-elements-plus'
import {mapGetters, mapState} from "vuex";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import {loadStripe} from '@stripe/stripe-js';

export default {
    name: 'CatUxoFormRegister',
    components: {
        Card,
        PulseLoader,
    },
    props: {
        plan: {
            type: String,
            required: false,
        },
        org: {
            type: Object,
            required: false,
        }
    },
    data: function () {
        return {
            form: {
                csrfToken: null,
                fullName: null,
                email: null,
                phone: null,
                country: null,
                trainedAt: null,
                currentWork: null,
                explanation: null,
                purpose: null,
                password: null,
                passwordConfirmation: null,
                toc: false,
                organisationId: null
            },
            registration: false,
            countries: [],
            complete: false,
            loading: false,
            user: '',
            errors: [],

            }
        },
        computed: {
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            rules() {
                return {
                    fullName: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    country: {
                        required: requiredIf(() => !this.org)
                    },
                    trainedAt: {
                        required: requiredIf(() => !this.org)
                    },
                    currentWork: {
                        required: requiredIf(() => !this.org)
                    },
                    explanation: {
                        required: requiredIf(() => !this.org)
                    },
                    purpose: {
                        required: requiredIf(() => !this.org)
                    },
                    password: {
                        required,
                    },
                    passwordConfirmation: {
                        required,
                        sameAsPassword: sameAs('password')
                    },
                    toc: {
                        checked: value => value === true
                    }
                }

        },
    },
    methods: {
        fetchCountries() {
            return axiosApi.get(`/api/v1/countries`)
                .then(response => {
                    if (response.data) {
                        this.countries = response.data.data
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        next() {
            this.$v.form.$touch();

            if (!this.$v.form.$invalid) {
                this.step++;
            }
        },
        scrollTop() {
            window.scrollTo(0, 0);
        },

        async loadStripe() {
            this.stripe = await loadStripe(this.stripeKey);

            this.elements = this.stripe.elements();
            this.card = this.elements.create('card', {style: this.style});
            this.card.mount(this.$refs.card);
        },

        createAccount() {
            const $this = this;

            $this.$v.form.$touch();
            if ($this.$v.form.$invalid) {
                return;
            }

            this.loading = true;

            return axiosWeb.post(`/api/v1/register`, $this.form)
                .then(({data}) => {
                    $this.user = data;
                    $this.registration = true;
                    $this.loading = false;
                    $this.step = 0;
                }).catch((e) => {
                    this.loading = false
                    this.errors = e.response.data.errors
                })
        },
    },
    created() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        this.fetchCountries();
    },
    validations() {
        return {
            form: this.rules
        }
    },
    mounted() {
        if (this.org) this.form.organisationId = this.org.id
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/forms/Register.vue